import {FormattedMessage} from '@pinecast/i18n';
import styled from '@pinecast/styles';
import * as React from 'react';

import Button from './Button';
import {VerticalGroup} from './Group';
import {useIsDarkMode} from './hooks/useIsDarkMode';
import {ErrorIcon} from './icons';

const TitleWrapper = styled('h2', (_, designColors) => ({
  color: designColors.headingBlue,
  fontFamily: 'Monument Grotesk Bold',
  fontSize: 14,
  fontWeight: 400,
  marginBottom: 0,
  marginTop: 0,
  textAlign: 'center',
}));
const TextWrapper = styled('div', (_, designColors) => ({
  color: designColors.contentTextAccent,
  fontSize: 13,
  lineHeight: 16,
  textAlign: 'center',
}));

const ErrorState = ({
  actionLabel,
  onAction,
  title,
  copy,
}: {
  actionLabel?: React.ReactNode;
  onAction?: string | (() => void);
  title: React.ReactNode;
  copy?: React.ReactNode;
}) => {
  const darkMode = useIsDarkMode();
  return (
    <VerticalGroup
      spacing={16}
      centerChildren
      wrapperStyle={{
        maxWidth: 400,
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: '12px 0',
      }}
    >
      {copy ? (
        <ErrorIcon size={48} />
      ) : (
        <img
          src={
            darkMode
              ? '/static/img/dashboard/error.dark.png'
              : '/static/img/dashboard/error.png'
          }
          alt=""
          height={300}
          width={385.5}
        />
      )}
      <TitleWrapper>{title}</TitleWrapper>
      {Boolean(copy) && <TextWrapper>{copy}</TextWrapper>}
      {Boolean(onAction) && (
        <Button
          {...(typeof onAction === 'string'
            ? {href: onAction}
            : {onClick: onAction})}
          size="small"
        >
          {actionLabel || (
            <FormattedMessage
              description="Default retry button when an error is shown"
              defaultMessage="Retry"
            />
          )}
        </Button>
      )}
    </VerticalGroup>
  );
};

export default ErrorState;
